import { render, staticRenderFns } from "./PinModal.vue?vue&type=template&id=b8b6e75a&scoped=true&"
import script from "./PinModal.vue?vue&type=script&lang=js&"
export * from "./PinModal.vue?vue&type=script&lang=js&"
import style0 from "./PinModal.vue?vue&type=style&index=0&id=b8b6e75a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b6e75a",
  null
  
)

export default component.exports